/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import React, { useRef, useState, useEffect } from 'react';
import { Labeled } from 'react-admin';
import _differenceBy from 'lodash/differenceBy';
import _reduce from 'lodash/reduce';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

import dataProvider from '../providers/data-provider';

function orderAssetsByRefs(assets, refs) {
  const assetsByRef = _reduce(
    assets,
    function (result, asset) {
      result[asset.extraData.ref] = asset;
      return result;
    },
    {}
  );

  const orderedAssets = [];

  for (let ref of refs) {
    const assetFound = assetsByRef[ref];
    if (assetFound) orderedAssets.push(assetFound);
  }

  return orderedAssets;
}

const AssetsRefs = ({ assetsAdded, assetsInList }) => {
  const [search, setSearch] = useState();
  let input = useRef(null);

  useEffect(() => {
    const fetchAssets = async (searchValue) => {
      let assets = await dataProvider.getTotalList('assets', {
        filter: { q: searchValue },
      });

      assets.data = orderAssetsByRefs(assets.data, searchValue);

      // Filter existing assets
      if (assets.total !== 0) {
        const filteredAssets = _differenceBy(assets.data, assetsInList, 'id');
        assetsAdded(filteredAssets);
        input.current.value = '';
      }
    };

    if (search) {
      fetchAssets(search);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  const handleAddByRefs = () => {
    const { value } = input.current;
    const newAssets = value.match(/(#(IBL|MESH)?[0-9]+)/gi);

    if (!newAssets) return;

    setSearch(newAssets);
  };

  return (
    <>
      <Labeled label="Comma separated ref" fullWidth>
        <TextField multiline inputRef={input} fullWidth />
      </Labeled>
      <Button variant="contained" color="primary" onClick={handleAddByRefs}>
        Add refs
      </Button>
    </>
  );
};

AssetsRefs.propTypes = {};

export default AssetsRefs;
